/**
 * Return an array of all dates between start and end of a period
 * 
 * @param {String} startDate start of period
 * @param {String} endDate end of period
 * @param {String} mode needed for add dates between period (days, weeks, months, ...)
 * @param {*} format wanted format of date for output
 * @return {Array} array of dates formated according format param
 */
export const enumeratePeriodsBetweenDates = function(startDate, endDate, mode, format) {
    const dates = [];

    const currDate = moment(startDate).subtract(1, mode);
    const lastDate = moment(endDate);

    while(currDate.add(1, mode).diff(lastDate) < 0) {
        dates.push(moment(currDate).format(format));
    }

    return dates;
};
